import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'coalesce',
})
export class CoalescePipe implements PipeTransform {
  transform(value: any | null | undefined, defaultValue: any): any {
    if (
      value === null ||
      value === undefined ||
      (Array.isArray(value) && value.length === 0) ||
      (typeof value === 'string' && value.trim() === '')
    ) {
      return defaultValue;
    }

    return value;
  }
}
